<template>
  <mds-combo-box
    class="modal-content__ftp"
    :label="label"
    :data-set="options"
    :selected-items="[selectedOption]"
    :error="!options.length"
    :disabled="!options.length"
    :errorText="[translate('scheduler.modal.delivery.ftp.error')]"
    @input="handleEvent"
  />
</template>

<script>
import MdsComboBox from '@mds/combo-box'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import defaultConfig from '@/components/schedulerModal/config/i18n'

export default {
  name: 'DestinationField',
  components: {
    MdsComboBox,
  },
  mixins: [MwcBaseHelpersMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: /* istanbul ignore next */ () => [],
    },
    editedFeed: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      defaultConfig,
      selectedOption: [],
    }
  },
  created() {
    this.selectedOption = this.savedOption
    this.$emit('input', this.selectedOption)
  },
  computed: {
    savedOption() {
      const selectedOption = this.options.find(
        (option) => option.value === this.editedFeed?.delivery_destination
      )

      return selectedOption ? selectedOption.value : this.preselectedItem
    },
    preselectedItem() {
      const [option = null] = this.options
      return option?.value || []
    },
  },
  methods: {
    handleEvent(event) {
      this.selectedOption = event[0]
      this.$emit('input', event[0])
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-content__ftp {
  &::v-deep [class^='mds-combo-box__single'] {
    margin-bottom: 0 !important;
  }
}
</style>
